import { UsendDoneMark, UsendLoadingMark } from "./UsendMarks";

// Toast content for Sync All: the loading mark while syncing, the U turning into a tick when done.
export default function SyncToast({ state }) {
  return (
    <span className="usend-sync-toast" role="status">
      {state === "done" ? <UsendDoneMark /> : <UsendLoadingMark />}
      <span>{state === "done" ? "Order synchronization successful" : "Syncing orders…"}</span>
    </span>
  );
}
